import { RouteRecordRaw } from 'vue-router';

import { popQueryOrParam } from '@/helpers/routerUtils';
import { LazyComponent } from '@/models/LazyComponent';

const BoletosView: LazyComponent = () => import(/* webpackChunkName: "boletos" */ './views/Boletos.vue');
const PropostaEmAnalise: LazyComponent = () => import(/* webpackChunkName: "boletos" */ './views/PropostaEmAnalise.vue');
const PagamentoPix: LazyComponent = () => import(/* webpackChunkName: "boletos" */ './views/PagamentoPix.vue');
const PagamentoBoleto: LazyComponent = () => import(/* webpackChunkName: "boletos" */ './views/PagamentoBoleto.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/divida/:api/:id/boletos',
    name: 'boletos',
    component: BoletosView,
    props: (route) => {
      const api = popQueryOrParam(route.params.api);
      const id = popQueryOrParam(route.params.id);
      const isAcordoExterno = route.query['acordo-externo'] === 'true';
      return {
        api,
        id: Number(id),
        isAcordoExterno,
      };
    },
  },
  {
    path: '/divida/:api/:id/proposta-aceita',
    name: 'proposta-aceita',
    component: BoletosView,
    props: (route) => {
      const api = popQueryOrParam(route.params.api);
      const id = popQueryOrParam(route.params.id);

      return {
        api,
        id: Number(id),
        isFirstView: true,
      };
    },
  },
  {
    path: '/divida/:api/:idProposta/boletos/:numeroParcela(\\d+)/pix',
    name: 'pagamento-parcela-pix',
    component: PagamentoPix,
    props: (route) => {
      const api = popQueryOrParam(route.params.api);
      const idProposta = popQueryOrParam(route.params.idProposta);
      const numeroParcela = popQueryOrParam(route.params.numeroParcela);
      const isAcordoExterno = route.query['acordo-externo'] === 'true';

      return {
        api,
        idProposta,
        numeroParcela,
        isAcordoExterno,
      };
    },
  },
  {
    path: '/divida/:api/:idProposta/boletos/:numeroParcela(\\d+)/boleto',
    name: 'pagamento-parcela-boleto',
    component: PagamentoBoleto,
    props: (route) => {
      const api = popQueryOrParam(route.params.api);
      const idProposta = popQueryOrParam(route.params.idProposta);
      const numeroParcela = popQueryOrParam(route.params.numeroParcela);
      const isAcordoExterno = route.query['acordo-externo'] === 'true';

      return {
        api,
        idProposta,
        numeroParcela,
        isAcordoExterno,
      };
    },
    meta: {
      appBg: '#fff',
    },
  },
  {
    path: '/divida/:api/:idProposta/proposta-em-analise',
    name: 'proposta-em-analise',
    component: PropostaEmAnalise,
  },
];

export default routes;
